<app-spinner-overlay></app-spinner-overlay>

<h2 mat-dialog-title>Configurazione Informativa Aziendale</h2>
<div mat-dialog-content class="dialog-center-cont" style="display: flex">
  <form [formGroup]="formInfoAz">
    <div appFormContainer [larghezza]="4">
      <mat-form-field appFormElement [larghezza]="1.5" [riempi]="true">
        <mat-label>Titolo</mat-label>
        <input matInput placeholder="Nome Breve" formControlName="titolo" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <mat-form-field appFormElement [larghezza]="2.5" [riempi]="true">
        <mat-label>Descrizione</mat-label>
        <input matInput placeholder="Descrizione" formControlName="descrizione" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <!-- Standard di rendicontazione -->
      <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
        <mat-label>Standard di rendicontazione</mat-label>
        <mat-select
          formControlName="stdr"
          (selectionChange)="onSelectSTDR()"
          [compareWith]="compareSTDR"
        >
          <mat-option>--</mat-option>
          @for (stdr of stdrArray; track stdr.id) {
            <mat-option [value]="stdr">{{ stdr.codice }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Compliance Normativi -->
      <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
        <mat-label>Compliance Normativi</mat-label>
        <mat-select
          formControlName="compliance"
          (selectionChange)="onSelectCompliance()"
          [compareWith]="compareSTDR"
        >
          <mat-option>--</mat-option>
          @for (compliance of complianceArray; track compliance.id) {
            <mat-option [value]="compliance">{{ compliance.codice }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div style="height: 10px"></div>
    <!-- TABBE -->
    <ng-container *ngFor="let sezioniArr of $any(formInfoAz.get('sezioni'))?.controls">
      <div class="cnt-domande-bottoni">
        <div class="cnt-domande">
          <ng-scrollbar>
            <div style="margin-right: 20px">
              <ng-container
                [ngTemplateOutlet]="accordionDomande"
                [ngTemplateOutletContext]="{ sezioniArr: sezioniArr }"
              ></ng-container>
            </div>
          </ng-scrollbar>
        </div>
        <div class="cnt-bnt">
          <button mat-stroked-button (click)="apriCfgDomande()" class="btn-add">
            Seleziona tra le domande disponibili
          </button>

          <button
            mat-stroked-button
            (click)="addDomanda(sezioniArr.get('domande').controls)"
            class="btn-add"
          >
            Aggiungi Domanda
          </button>
        </div>
      </div>
    </ng-container>
  </form>
  <div style="height: 10px"></div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salvaInfoAz()" class="primary-button">
      Salva
    </button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="pubblica()" class="primary-button">
      Pubblica
    </button>
  </div>
</div>

<ng-template #accordionDomande let-sezioniArr="sezioniArr">
  <mat-accordion>
    <div cdkDropList (cdkDropListDropped)="drop($event, sezioniArr)" class="cnt-accordion">
      <mat-expansion-panel
        [id]="'DOM_' + domandeArr.get('id').value"
        expanded="false"
        (afterExpand)="scrollaInView(anchor)"
        *ngFor="let domandeArr of sezioniArr.get('domande').controls; let idx = index"
        cdkDrag
      >
        <div #anchor></div>
        <div *cdkDragPlaceholder></div>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <button mat-icon-button title="Sposta" aria-label="Sposta">
              <mat-icon> drag_handle </mat-icon>
            </button>
            <span class="domanda">
              {{ domandeArr.get('domanda').value }}
            </span>
          </mat-panel-title>
          <mat-panel-description>
            <div class="testo-risposta">
              <!--    {{domandeArr.get("valore").value}} -->
            </div>

            <button
              class="btn-delete"
              mat-icon-button
              title="Elimina"
              aria-label="Elimina"
              color="warn"
              (click)="
                $event.stopPropagation();
                elimina(sezioniArr.get('domande'), idx, domandeArr.get('id').value)
              "
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>

        @if (ctrArrayCategorie()) {
          <div style="margin-top: 10px">
            <app-dialog-crea-domande-informativa
              [arrayCategorie]="arrayCategorie"
              (inserimentoDoamanda)="sincronizzaDomanda($event, domandeArr)"
              [mappaCategorieUm]="mappaCategorieUm"
              [inputDomande]="domandeArr.getRawValue()"
            ></app-dialog-crea-domande-informativa>
          </div>
        }
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</ng-template>
